import { apiRequest } from '@/integrations/api/client';

export interface AgentConversationDto {
  id: string;
  tenant_id: string;
  user_id: string;
  title: string;
  started_at: string;
  created_at: string;
  updated_at: string;
}

export interface AgentMessageDto {
  id: string;
  conversation_id: string;
  tenant_id: string;
  role: string;
  content: string;
  ui_actions: unknown;
  tokens_input: number | null;
  tokens_output: number | null;
  cost_eur: number | null;
  created_at: string;
}

export async function fetchAgentConversations(userId: string, tenantId?: string | null) {
  const res = await apiRequest<{ conversations: AgentConversationDto[] }>(
    `/api/agent/conversations?user_id=${encodeURIComponent(userId)}`,
    { tenantId },
  );
  return res.conversations;
}

export async function createAgentConversation(
  body: { user_id?: string; title?: string },
  tenantId?: string | null,
) {
  const res = await apiRequest<{ conversation: AgentConversationDto }>('/api/agent/conversations', {
    method: 'POST',
    tenantId,
    body,
  });
  return res.conversation;
}

export async function fetchAgentMessages(conversationId: string, tenantId?: string | null) {
  const res = await apiRequest<{ messages: AgentMessageDto[] }>(
    `/api/agent/conversations/${conversationId}/messages`,
    { tenantId },
  );
  return res.messages;
}

export async function createAgentMessage(
  conversationId: string,
  body: { role: string; content?: string },
  tenantId?: string | null,
) {
  const res = await apiRequest<{ message: AgentMessageDto }>(
    `/api/agent/conversations/${conversationId}/messages`,
    { method: 'POST', tenantId, body },
  );
  return res.message;
}

export async function fetchAgentActions(tenantId?: string | null) {
  const res = await apiRequest<{ actions: any[] }>('/api/agent/actions', { tenantId });
  return res.actions;
}

export async function executeAgentTool(
  body: { tool_name: string; params: Record<string, unknown>; idempotency_key?: string; session_id?: string },
  tenantId?: string | null,
) {
  return apiRequest<{ ok: boolean; result?: Record<string, unknown>; error?: string }>(
    '/api/agent/execute',
    { method: 'POST', tenantId, body },
  );
}
